<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <h2>Lokální názvoslovné systémy</h2>
                <div class="mt-5 mb-5">
                    <img
                        src="../../public/img/articles/lokalni_nazvoslovne_systemy.webp"
                        alt=""
                        class="mb-1 aspect-auto w-full object-cover"
                    />
                    <span class="source"
                        >Nejstarší názvoslovný systém vznikl na Žižkově. /
                        Zdroj: Ústřední archiv zeměměřictví a katastru</span
                    >
                </div>
                <p class="mb-5 font-bold">
                    Lokální systémy pojmenování ulic vznikly v Praze v 19.
                    století. Obliba pojmenovávat sousední ulice v jedné oblasti
                    podle souvisejících událostí, osobností, obcí, rostlin či v
                    místě obvyklých názvů přetrvává v hlavním městě dodnes.
                </p>

                <p class="font-bold">Historie názvoslovných systémů</p>
                <p class="mb-5">
                    Nejstarší názvoslovný systém vznikl v roce 1872 na Žižkově,
                    kde byly názvy ulic spjaty s husitským hnutím. Úředně
                    pojmenovány zde byly ulice
                    <span class="italic">Husova, Poděbradova</span> či

                    <span class="italic">Žižkovo náměstí. </span>

                    Mezi lety 1892–1900 vznikl názvoslovný systém také v
                    Nuslích. Ulice zde byly pojmenovány podle starých českých,
                    polských a dalších slovanských knížat i mytologických
                    osobností (<span class="italic"
                        >Boleslavova, Čestmírova, Jaromírova, Křesomyslova,
                        Mečislavova, Mojmírova, Oldřichova, Svatoslavova</span
                    >). Vytváření názvoslovných systémů bylo později oblíbeno
                    vždy, a to jak v období 1. republiky (kdy vznikl např.
                    systém pojmenování dejvických a bubenečských ulic
                    připomínající místa a události 1. světové války nebo
                    Jiráskova čtvrť, ve které názvy ulic vycházejí z díla Aloise
                    Jiráska), tak i po roce 1945, a to zejména v období od 60.
                    let 20. století, kdy začala vznikat velká pražská sídliště s
                    celým hroznem ulic, které bylo třeba naráz pojmenovat (Krč,
                    Zahradní Město, Barrandov aj.). Tehdy se takové systémy
                    staly takřka nutností, protože vymyslet vhodné názvy pro
                    stovky ulic najednou skutečně není jednoduché. Pro okrajové
                    městské části byl doporučen typ pojmenování tvořený podle
                    měst a obcí, případně i podle krajových označení (např.
                    <span class="italic"> Hanácká, Valašská</span>), který je
                    vhodný také z hlediska jazykové praxe. Proto bylo území
                    Prahy rozděleno na 4 sektory, přičemž každý sektor měl
                    přidělené jednotlivé okresy republiky, z jejichž názvů měst
                    a obcí mohly jednotlivé Obvodní národní výbory a Místní
                    národní výbory v případě potřeby čerpat názvy ulic. Reálný
                    stav pak ukázal, že se v případě připojených obcí stal tento
                    typ pojmenování nikoli doplňujícím, ale spíše převažujícím.
                    Dnes jsou do vzdálenosti zhruba 80 km od Prahy téměř všechny
                    názvy obcí obsaženy v pražském uličním názvosloví.
                </p>

                <p class="font-bold">Výhody, nevýhody a účel</p>
                <p class="mb-5">
                    Názvoslovné systémy mají velkou výhodu: vcelku neomezenou
                    možnost přidávat další názvy ulic podle toho, jak výstavba
                    pokračuje. Výhodné je z tohoto hlediska zavádění politicky
                    neutrálních názvů (jako např. podle již uvedených obcí nebo
                    rostlin), neboť při politických změnách nevyvstává tlak na
                    přejmenování, a tudíž jsou takové názvy ulic velice
                    stabilní, což je pro orientaci i občany nanejvýš žádoucí.
                    Zcela nevýhodným z výše uvedeného hlediska se ukázal
                    názvoslovný celek zvolený podle ruských spisovatelů –
                    revolučních demokratů, a zejména představitelů různých
                    komunistických či dělnických hnutí z různých období na
                    sídlišti Horní Měcholupy v polovině 70. let 20. století
                    (<span class="italic"
                        >Mikojanova, Gramsciho, Hočiminova, Togliattiho
                    </span>

                    aj.). Tento systém byl zcela nahrazen v roce 1993
                    pojmenováním podle italských měst a různých sportů (ve
                    stejném pořadí:
                    <span class="italic"
                        >Janovská, Boloňská, Horolezecká, Sáňkařská</span
                    >
                    aj.). Podobný osud potkal sídliště Černý Most II, kde byly v
                    roce 1981 ulice pojmenovány podle zahraničních
                    komunistických funkcionářů (<span class="italic"
                        >Švernikova, Kuzněcovova, Komjatova
                    </span>

                    aj.) a v roce 1991 došlo k jejich kompletnímu přejmenování
                    podle československých válečných letců, účastníků
                    protifašistického odboje (ve stejném pořadí:

                    <span class="italic">
                        Ocelkova, generála Janouška, Šromova
                    </span>

                    aj.).
                </p>

                <p class="font-bold">Systémy dnes</p>
                <p class="mb-5">
                    V zavedených názvoslovných systémech se pokračuje dodnes,
                    přičemž se stále objevují i nové. Tak např. Sluneční čtvrť
                    (vzniká od roku 2001) nebo obytný soubor Harmonie (vzniká od
                    roku 2004). Zajímavým nápadem je navazování na názvy ulic na
                    Zahradním Městě v oblasti tzv. Nového Zahradního Města, kde
                    jsou od roku 2006 užívána jména botaniků žijících zejména v
                    minulých staletích (<span class="italic"
                        >Mikanova, Mattioliho, Velenovského, Kamelova</span
                    >). Stávající názvoslovné systémy jsou rozvíjeny nejčastěji
                    v souvislosti s potřebou pojmenování nově postavených ulic –
                    např. v Malešicích (názvy související s Karlovou
                    univerzitou), v Pitkovicích (názvy podle hub), v Hostivaři
                    (názvy podle hlavních měst evropských států) a jinde. Stále
                    oblíbené jsou také názvy podle obcí (Letňany, Ďáblice, Újezd
                    nad lesy, Vinoř, Jinonice, Sobín, Zličín aj.), osobností
                    (Kolovraty – výtvarní umělci, Satalice – čeští herci, Černý
                    Most – letci RAF), bylin a rostlin (Kolovraty, Křeslice) či
                    podle ptáčků (Březiněves). Zajímavé názvy přináší snaha o
                    upozornění na místní historii, jako např. ve Štěrboholech,
                    kde ulice

                    <span class="italic"> Dragounská, Granátnická</span>
                    či
                    <span class="italic">Laudonova</span>

                    připomínají bitvu u Štěrbohol v roce 1757. Příhodná
                    pojmenování vznikají také ve Kbelích a Ruzyni, kde uliční
                    názvy podle průkopníků letectví evokují místní letiště
                    (<span class="italic"
                        >Blériotova, Kašparova, Laglerové
                    </span>

                    aj.). Praha má zhruba 140 lokálních názvoslovných systémů.
                </p>

                <p class="font-bold">Výjimky, rozpory a nejasnosti</p>
                <p class="mb-5">
                    Snahy o vytvoření názvoslovného systému nejsou a nemohou být
                    v rámci Prahy bezvýhradně určující – nelze automaticky
                    předpokládat, že např. ulice

                    <span class="italic">Borůvková</span>

                    je na Zahradním Městě, protože se jmenuje podle rostliny
                    (<span class="italic">Borůvková</span> je v Křeslicích),
                    nebo <span class="italic">Helsinská</span> v Hostivaři, kde
                    jsou ulice pojmenovány podle hlavních evropských měst (<span
                        class="italic"
                        >Helsinská</span
                    >
                    je v Třebonicích).
                </p>
                <p class="mb-5">
                    Příkladem může být také pojmenování ulic podle kalendářních
                    měsíců. Roku 2005 byly v Ďáblicích pojmenovány ulice

                    <span class="italic">
                        Březnová, Červencová, Červnová, Srpnová, Zářijová a
                        Prosincová
                    </span>

                    proto, že už se tu nacházely ulice

                    <span class="italic">Květnová </span>

                    (1971) a

                    <span class="italic">Říjnová</span>

                    (1971) – ty ovšem byly nazvány podle historických událostí,
                    které se v nich staly (květnové povstání 1945 a říjnová
                    revoluce 1917). Navíc stejně není možné použít v Ďáblicích
                    zbývající měsíce, protože

                    <span class="italic">Lednová</span>
                    s
                    <span class="italic">Únorovou</span>
                    jsou již v Nedvězí (první od roku 2001, druhá dokonce už od
                    roku 1974) a

                    <span class="italic">Listopadová</span>

                    v Dolních Počernicích (od roku 1992). V této chvíli chybí už
                    jen

                    <span class="italic">Dubnová</span>

                    (vynechání tohoto měsíce má zřejmě ryze praktický důvod – na
                    Hájích existuje od roku 1978 ulice Dubnova, rozdíl v názvu
                    by pak představovala pouze délka písmene „a“, tudíž by mohlo
                    snadno docházet k záměně).
                </p>
                <p class="mb-5">
                    Je však otázka, zda jsou tyto lokální tzv. urbanonymické
                    systémy vždy zcela vhodné a zda skutečně usnadňují
                    orientaci. Kromě výše uvedených příkladů ne úplně
                    systémových pojmenování může také docházet k tomu, že si
                    lidé budou názvy plést a místo usnadnění orientace budou jen
                    vědět, že ulice se jmenuje po nějaké vesnici, houbě,
                    rostlině apod. A to nemluvíme o záměně podobných názvů, jako
                    např. v Křeslicích (<span class="italic">U Vlasačky</span>
                    –
                    <span class="italic">Za Vlasačkou</span>
                    –
                    <span class="italic">Na Vlasačce</span>).
                </p>

                <p class="font-bold">Systémy – jediná možnost do budoucna?</p>
                <p class="mb-10 sm:mb-25">
                    Nicméně v kontextu situace, kdy v Praze vznikají takřka
                    denně nové ulice a každá musí mít svůj jedinečný,
                    nezaměnitelný a neopakující se název, je úkol najít takový
                    nový, neotřelý, dobře se vyslovující, jednoduše a
                    jednoznačně se píšící a nejlépe ještě pěkný název téměř
                    nadlidský (vezmeme-li navíc v úvahu, že téměř 8 tisíc názvů
                    již bylo použito). Názvy mnoha rostlin jsou již vyčerpány,
                    téměř všechny obce do vzdálenosti desítek kilometrů od Prahy
                    již mají svou ulici, podobně jako významné osobnosti a už i
                    stará pomístní pojmenování „docházejí“. A proto budou mít
                    jistě i v budoucnosti tyto lokální názvoslovné systémy se
                    všemi výhodami i nevýhodami své místo v pražském uličním
                    názvosloví.
                </p>

                <!-- next chapters -->
                <div class="mb-10 flex justify-between border-t-1 pt-5">
                    <p class="mb-5 w-1/2 border-r-1 font-bold">
                        <nuxt-link
                            to="/clanky/historie-ulic-po-roce-1989"
                            class="flex justify-start underline"
                        >
                            <img
                                src="../../public/img/left-arrow.png"
                                alt=""
                                class="order-1 mr-2 inline h-5 w-5"
                            />
                            <span class="order-2 mr-2"
                                >Historie ulic po roce 1989</span
                            >
                        </nuxt-link>
                    </p>
                    <p class="mb-5 w-1/2 text-right font-bold">
                        <nuxt-link
                            to="/clanky/pocty-ulic"
                            class="flex justify-end underline"
                        >
                            <span class="order-1 ml-2">Počty ulic</span>
                            <img
                                src="../../public/img/right-arrow.png"
                                alt=""
                                class="order-2 ml-2 inline h-5 w-5"
                            />
                        </nuxt-link>
                    </p>
                </div>
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
